import React, { useState } from 'react';
import ModalComponent from 'components/common/ModalComponent';
import ButtonComponent from 'components/common/ButtonComponent';
import { showAlert } from 'services/alerts.service';
import { makeRequest } from 'services/request.service';

import { useAuth } from 'auth/AuthContext';

import PropTypes from 'prop-types';

const UploadFarmingBlockModal = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file.type;
      if (fileType !== 'text/csv') {
        setError('Please upload a valid CSV file.');
        setSelectedFile(null);
      } else {
        setError('');
        setSelectedFile(file);
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!selectedFile) {
      setError('No file selected. Please choose a CSV file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      // Replace with your API request logic
      await makeRequest({
        method: 'POST',
        url: `/management/farming-blocks/upload/${user.farmId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        },
        alertResult: true
      });
      showAlert({ title: 'Success', html: 'File uploaded successfully!', icon: 'success' });
      onClose();
    } catch (err) {
      console.error('Upload Error:', err);
      setError('Failed to upload the file. Please try again.');
    }
  };

  const customFooter = (
    <ButtonComponent
      type="submit"
      customColorsStyles="bg-gray-100 text-greenPrimary hover:text-white"
      onClick={onClose}
    >
      Close
    </ButtonComponent>
  );

  return (
    <ModalComponent
      title="Upload Farming Block CSV"
      isOpen={isOpen}
      onClose={onClose}
      customFooter={customFooter}
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <input type="file" accept=".csv" onChange={handleFileChange} />
          {error && <p className="text-red-600">{error}</p>}
        </div>
        <ButtonComponent type="submit" className="bg-greenPrimary text-white">
          Upload
        </ButtonComponent>
      </form>
    </ModalComponent>
  );
};

UploadFarmingBlockModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default UploadFarmingBlockModal;
